
const TableSkeletonRow = ({ columns }: { columns: number }) => (
  <tr>
    {Array.from({ length: columns }).map((_, i) => (
      <td key={i}>
        <div className="shimmer-bg" style={{ height: '35px', borderRadius: '4px' }}></div>
      </td>
    ))}
  </tr>
);

const TableSkeleton = ({ columns, rows }: { columns: number, rows: number }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <TableSkeletonRow key={i} columns={columns} />
      ))}
    </>
  );
};

export default TableSkeleton;
